import React from 'react';
import { useParams } from 'react-router-dom';
import { Square, Flex, Loader } from '@grubhubprod/gh-cookbook-react';
import { IErrorResponse } from 'src/utilities/shared-types';
import {
  SdkErrorResponse,
  pushErrorFromAPI,
} from 'src/utilities/notifications';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { PageTitle } from 'src/components/enterprise/layout/PageTitle/PageTitle';
import { CorporateForm } from 'src/components/enterprise/features/Corporate/components/Form/CorporateForm';
import { CorporateFieldsProvider } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/CorporateFieldsProvider';
import { useCorporateEditPage } from 'src/components/enterprise/features/Corporate/EditPage/hooks/useCorporateEditPage';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { getWindow } from 'src/utilities/window';

export const CorporateEditPage: React.FC = () => {
  const { corpid: corpId } = useParams<{ corpid: string }>();
  const onSuccess = async (): Promise<void> => {
    const window = getWindow();
    window.location.href = `${window.location.origin}/groupadmin/corps`;
  };
  const onError = async (
    error: IErrorResponse | SdkErrorResponse
  ): Promise<void> => {
    pushErrorFromAPI(error);
  };
  const { corpData, corpFormValues, updateCorp, getCorpLoading, getCorpError } =
    useCorporateEditPage({
      corpId,
      onSuccess,
      onError,
    });

  if (getCorpError) {
    return null;
  }

  const isEditPage = Boolean(corpId);

  return (
    <Square inset="lg">
      <PageHeader>
        <PageTitle title="Edit Client" />
        <Breadcrumbs
          breadcrumbs={[
            {
              label: 'Corps',
              href: `/groupadmin/corps`,
            },
          ]}
        />
      </PageHeader>

      {getCorpLoading ? (
        <Flex justifyContent="center">
          <Loader size="lg" />
        </Flex>
      ) : (
        <CorporateFieldsProvider>
          <CorporateForm
            corpData={corpData}
            defaultValues={corpFormValues}
            onSubmit={updateCorp}
            isEditPage={isEditPage}
          />
        </CorporateFieldsProvider>
      )}
    </Square>
  );
};
